export const sv = {
  translation: {
    yes: 'Ja',
    no: 'Nej',
    i_dont_know: 'Jag vet inte',
    loading: 'Laddar',
    error: 'Fel',
    what_its_about: 'Vad gäller ditt ärende?',
    illness: 'Sjukdom/symtom',
    other_reason: 'Annat',
    next: 'Nästa',
    digichat247: 'Chatt med digital sjukskötare för företagshälsokunder 24/7',
    return_to_start: 'Gå tillbaka och rensa svaren',
    start_by_giving_anamnesis: 'Börja med att ge förhandsuppgifter',
    chat_preliminary_questionaire: 'Förhandsuppgifter för chatt',
    start_preliminary_questionaire: 'Börja fylla i förhandsuppgifter',
    search: 'Sök',
    search_for_symptoms: 'Sök symtom eller sjukdom',
    search_continue_writing: 'Fortsätter att skriva',
    search_no_results: 'Inga sökresultat',
    step_your_symptoms: 'Dina symtom',
    step_questions: 'Frågor',
    step_summary: 'Sammanfattning',
    what_symptoms_you_have: 'Vilka symtom har du?',
    most_popular_symptoms: 'De vanligaste symtomen',
    select_symptom: 'Välj ett symtom',
    remove_selected_symptom: 'Ta bort det valda symtomet',
    symptoms_you_chose: 'Valda symtom',
    no_selected_symptoms: 'Inga symtom valda',
    select_symptoms_and_proceed: 'Välj 1–3 av de mest påtagliga symtomen',
    error_max_selected_symptoms: ' Du kan välja upp till 3 symtom eller sjukdomar.',
    popular_symptoms_heartburn: 'Halsbränna',
    popular_symptoms_dizziness: 'Yrsel',
    popular_symptoms_stomach_ache: 'Magont',
    popular_symptoms_headache: 'Huvudvärk',
    popular_symptoms_back_pain: 'Ryggont',
    popular_symptoms_fever: 'Feber',
    answer_to_questions: 'Svara på frågorna',
    your_symptoms_duration: 'Hur länge har dina symtom varat?',
    under_one_day: 'Minde än 1 dygn',
    one_to_two_days: '1 - 2 dygn',
    two_to_three_days: '2 - 3 dygn',
    over_three_days: 'Mer än 3 dygn',
    more_information: 'Mer information',
    write_information: 'Ange uppgifter',
    error_missing_information: 'Svara på alla frågor.',
    error_remote_data_failure:
      'Enkäten för förhandsuppgifter kan inte visas just nu. Försök ladda om sidan eller fortsätt direkt till chattmottagningen.',
    summary: 'Sammanfattning',
    continue_to_chat: 'Fortsätt till chatten',
    your_answers_are_send_to_specialist:
      'Förhandsuppgifterna vidarebefordras till en specialist då du kommer in i chatten',
    choose_what_symptoms_you_have: 'Välj vilka symtom du har',
    answer_to_specifying_questions: 'Svara på preciserande frågor',
    check_summary_and_continue_to_chat: 'Kontrollera sammanfattningen och gå till chattkön',
    patient: 'Patient',
    reason_of_contacting: 'Orsak till att patienten tagit kontakt',
  },
};
